import { DiagramSettings } from "./DiagramSettings";
import { ImageStencil } from "./ImageStencil";

/**
 * Lightbulb icon stencil is an icon stencil displaying a lightbulb.
 * It's main purpose is to serve as a sample for creating icon/clipart
 * stencils by extending the {@link core!ImageStencil}.
 */
export class LightbulbIconStencil extends ImageStencil {
  public static typeName = 'LightbulbIconStencil';

  public static title = 'Lightbulb';

  protected static DEFAULT_TEXT = 'Idea!';

  protected static svgString = '<path d="M12,6A6,6 0 0,1 18,12C18,14.22 16.79,16.16 15,17.2V19A1,1 0 0,1 14,20H10A1,1 0 0,1 9,19V17.2C7.21,16.16 6,14.22 6,12A6,6 0 0,1 12,6M14,21V22A1,1 0 0,1 13,23H11A1,1 0 0,1 10,22V21H14M20,11H23V13H20V11M1,11H4V13H1V11M13,1V4H11V1H13M4.92,3.5L7.05,5.64L5.63,7.05L3.5,4.93L4.92,3.5M16.95,5.63L19.07,3.5L20.5,4.93L18.37,7.05L16.95,5.63Z" />';

  /**
   * {@inheritDoc core!ConnectorBase.constructor}
   */    
  constructor(iid: number, container: SVGGElement, settings: DiagramSettings) {
    super(iid, container, settings);

    this.defaultSize = { width: 50, height: 80 };
    
    this._fillColor = '#fde047';
    this.strokeEditable = false;
    this.setStrokeWidth(0);
  }
}
